import axios from "axios";
import { clearLocalStorage } from "../utils/localStorage";

export const basePath =
  window.location.origin === "http://localhost:3000"
    ? "http://localhost:8080"
    : window.location.origin;

export const apiBasePath = `${basePath}/apiv2`;

export const logOff = () => {
  clearLocalStorage();
  window.location.assign(
    `${process.env.REACT_APP_TROCAR_APP_URL}/application/Login/logoff`
  );
};

export const getApplicationToken = () => {
  let data = window.localStorage.getItem("userData");
  if (data) {
    data = JSON.parse(data);
    return data.user.token;
  }
  return null;
};

const getPreferredLocale = () => {
  const localStorageLocale = window.localStorage.getItem("i18nextLng");

  if (localStorageLocale && localStorageLocale.trim() !== "") {
    return localStorageLocale;
  }

  if (navigator.language) {
    return navigator.language;
  }

  return "en-US";
};

  const apiV2 = axios.create({
    baseURL: apiBasePath
  })

  apiV2.interceptors.request.use((config) => {
    const token = getApplicationToken()
    const locale = getPreferredLocale()

    config.headers = {
      ...(config.headers || {}),
      "Accept-Language": locale,
      "X-Language": locale,
      "Access-Control-Allow-Origin": "*",
    }

    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }

    return config
  })

  export default apiV2
